export default __webpack_public_path__ + "static/media/aboutAnimation3.5b56d95c.png";